<template>
	<div class="vcx-alert vcx-inline-flex vcx-items-center vcx-gap-50 vcx-p-100" role="status" data-test="vcx-alert">
		<BaseSvgIcon v-if="icon" :name="icon" height="24" width="24" />
		<p class="vcx-my-0">
			<span v-if="heading" class="vcx-font-weight-semibold vcx-mr-25">{{ heading }}</span>
			<span v-if="message">{{ message }}</span>
		</p>
	</div>
</template>

<script setup lang="ts">
interface Props {
	heading?: string;
	icon?: string;
	message?: string;
}

defineProps<Props>();
</script>

<style lang="scss" scoped>
@use '../../styles/constants/colors' as *;

.vcx-alert {
	border-radius: var(--vcx-radius-50);
	background-color: token('info-background');
	color: token('content-primary');

	:deep(.svg-icon) {
		color: token('info');
	}
}
</style>
